form{display:flex;flex-direction:column;overflow-y:auto;padding-top:5px}.popover-action{display:flex;justify-content:flex-end}
/*# sourceMappingURL=add-edit-client-issue-dialog.component.css.map */
